import { StoreService } from '@/service/StoreService';

export function StoreServiceFactory() {
  return new StoreService();
}
